import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {RoomParty} from '../../../graphql/groups.datatypes';
import {gqlRoomParty} from './getRoomParties.api';

interface RoomPartiesData {
    roomPartiesInMyGroup: void,
    roomParties: void,
    myRoomParties: {
        data: RoomParty[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_ROOM_PARTIES_QUERY = gql`
  query getMyRoomParties($count: Int!, $page: Int!, $where: WhereConditions, $hasGroupBooking: QueryMyRoomPartiesHasGroupBookingWhereHasConditions, $orderBy: [OrderByClause!]){
    myRoomParties(first: $count, page: $page, where: $where, hasGroupBooking: $hasGroupBooking, orderBy: $orderBy){
      data {
        ${gqlRoomParty}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getMyRoomParties = (count: number, page: number, where?: any, orderBy?: any, hasGroupBooking?: any) => useQuery<RoomPartiesData>(
    GET_ROOM_PARTIES_QUERY,
    {
        variables: {
            count,
            page,
            where,
            hasGroupBooking,
            orderBy,
        },
    }
);

export default getMyRoomParties;
